export enum ChangeRequestState {
  Draft = 'Draft',
  PendingImport = 'PendingImport',
  Submitted = 'Submitted',
  Error = 'Error',
  Deleted = 'Deleted',
}
